import {POObject} from '@obj-models/POObject';

export default class POPersonPosition extends POObject {
  static type = 'PersonPosition';
  type = POPersonPosition.type;
}
